import { Box, BoxProps, ThemingProps, useStyleConfig } from '@chakra-ui/react';
import React from 'react';

interface OverlineProps {
  marginBottom?: BoxProps['marginBottom'];
  marginBlockEnd?: BoxProps['marginBlockEnd'];
  children?: React.ReactNode;
  colorScheme?: ThemingProps['colorScheme'];
}
const Overline: React.FC<OverlineProps> = ({
  children,
  colorScheme,
  ...props
}) => {
  const style = useStyleConfig('Overline', { colorScheme: colorScheme });

  if (!children) {
    return null;
  }

  return (
    <Box as="span" sx={style} {...props}>
      {children}
    </Box>
  );
};

export default Overline;
